export default __webpack_public_path__ + "static/media/icon-hamburger.f0db23b3.svg";